// AUTO-GENERATED — list of curated photos.
export const JOURNEY_PHOTOS = [
  "/mothersday/journey/00_PHOTO-2025-10-21-10-54-21.jpg",
  "/mothersday/journey/01_PHOTO-2025-10-23-12-14-49.jpg",
  "/mothersday/journey/02_PHOTO-2025-10-23-12-14-50_2.jpg",
  "/mothersday/journey/03_PHOTO-2025-11-28-21-18-55_6.jpg",
  "/mothersday/journey/04_PHOTO-2026-01-30-00-00-42.jpg",
  "/mothersday/journey/05_PHOTO-2026-02-14-21-36-07.jpg",
  "/mothersday/journey/06_PHOTO-2026-03-10-12-34-57.jpg",
  "/mothersday/journey/07_PHOTO-2026-03-11-00-41-41.jpg",
  "/mothersday/journey/08_PHOTO-2026-03-11-00-41-41_2.jpg",
  "/mothersday/journey/09_PHOTO-2026-04-13-11-01-07_2.jpg",
  "/mothersday/journey/10_PHOTO-2026-04-13-11-01-07.jpg",
  "/mothersday/journey/11_PHOTO-2026-04-26-10-28-39.jpg",
  "/mothersday/journey/12_PHOTO-2026-04-26-10-28-39_2.jpg",
  "/mothersday/journey/13_PHOTO-2026-04-27-20-50-51.jpg",
];

export const GALLERY_PHOTOS = [
  "/mothersday/gallery/00_mom_son_together_PHOTO-2026-04-13-11-01-07_2.jpg",
  "/mothersday/gallery/01_mom_son_together_PHOTO-2026-04-26-10-28-39_2.jpg",
  "/mothersday/gallery/02_mom_son_together_PHOTO-2026-02-14-21-36-07.jpg",
  "/mothersday/gallery/03_mom_son_together_PHOTO-2026-04-26-10-28-39.jpg",
  "/mothersday/gallery/04_mom_son_together_PHOTO-2026-01-30-00-00-42.jpg",
  "/mothersday/gallery/05_mom_son_hug_PHOTO-2025-10-23-12-14-49.jpg",
  "/mothersday/gallery/06_mom_son_hug_PHOTO-2025-11-28-21-18-55_6.jpg",
  "/mothersday/gallery/07_mom_son_hug_PHOTO-2026-04-27-20-50-48_3.jpg",
  "/mothersday/gallery/08_mom_son_hug_PHOTO-2025-12-07-00-13-05.jpg",
  "/mothersday/gallery/09_mom_kissing_son_PHOTO-2025-10-21-10-54-21.jpg",
  "/mothersday/gallery/10_mom_holding_baby_PHOTO-2026-03-10-12-34-57.jpg",
  "/mothersday/gallery/11_candid_family_PHOTO-2026-03-11-00-41-41.jpg",
  "/mothersday/gallery/12_candid_family_PHOTO-2026-03-11-00-41-41_2.jpg",
  "/mothersday/gallery/13_candid_family_PHOTO-2026-04-27-20-50-51.jpg",
  "/mothersday/gallery/14_aven_smiling_PHOTO-2026-03-09-11-29-14.jpg",
  "/mothersday/gallery/15_aven_smiling_PHOTO-2025-11-15-00-53-26.jpg",
  "/mothersday/gallery/16_aven_smiling_PHOTO-2026-03-11-01-14-21.jpg",
  "/mothersday/gallery/17_aven_smiling_PHOTO-2026-03-10-01-58-46.jpg",
  "/mothersday/gallery/18_aven_smiling_PHOTO-2026-03-09-11-22-57.jpg",
  "/mothersday/gallery/19_aven_celebration_PHOTO-2025-11-15-00-53-26_3.jpg",
  "/mothersday/gallery/20_aven_celebration_PHOTO-2025-11-15-00-53-26_2.jpg",
  "/mothersday/gallery/21_aven_celebration_PHOTO-2025-11-15-00-53-26_4.jpg",
  "/mothersday/gallery/22_aven_celebration_PHOTO-2025-11-03-20-34-39_2.jpg",
  "/mothersday/gallery/23_aastha_beautiful_PHOTO-2026-01-22-19-50-14.jpg",
  "/mothersday/gallery/24_aastha_beautiful_PHOTO-2026-04-26-10-35-35.jpg",
  "/mothersday/gallery/25_aastha_beautiful_PHOTO-2025-11-07-10-26-47.jpg",
  "/mothersday/gallery/26_family_three_PHOTO-2026-02-23-22-41-50.jpg",
  "/mothersday/gallery/27_family_three_PHOTO-2026-02-23-22-41-50_2.jpg",
  "/mothersday/gallery/28_family_three_PHOTO-2025-11-09-16-18-51.jpg",
  "/mothersday/gallery/29_family_three_PHOTO-2026-03-12-10-26-29.jpg",
  "/mothersday/gallery/30_family_three_PHOTO-2025-10-21-10-55-41.jpg",
  "/mothersday/gallery/32_aven_with_papa_PHOTO-2025-11-03-20-34-40_2.jpg",
  "/mothersday/gallery/33_aven_with_papa_PHOTO-2026-03-12-13-30-39.jpg",
  "/mothersday/gallery/34_aven_with_papa_PHOTO-2026-01-27-10-30-43.jpg",
  "/mothersday/gallery/38_aven_outdoor_PHOTO-2026-05-13-00-17-07.jpg",
  "/mothersday/gallery/39_aastha_traditional_PHOTO-2026-03-14-08-12-06.jpg",
  "/mothersday/gallery/40_aastha_traditional_PHOTO-2025-10-21-10-57-05_2.jpg",
  "/mothersday/gallery/41_new_PHOTO-2026-04-01-22-48-24.jpg",
  "/mothersday/gallery/42_new_PHOTO-2026-04-04-10-52-08.jpg",
  "/mothersday/gallery/43_new_PHOTO-2026-04-11-21-13-05.jpg",
  "/mothersday/gallery/44_new_PHOTO-2026-05-04-11-57-13.jpg",
  "/mothersday/gallery/45_new_PHOTO-2026-05-06-08-24-59.jpg",
];

export const MATCH_PHOTOS = [
  "/mothersday/match/00_PHOTO-2025-10-23-12-14-49.jpg",
  "/mothersday/match/01_PHOTO-2026-04-26-10-28-39_2.jpg",
  "/mothersday/match/02_PHOTO-2025-11-28-21-18-55_6.jpg",
  "/mothersday/match/03_PHOTO-2026-04-27-20-50-48_3.jpg",
  "/mothersday/match/04_PHOTO-2025-12-07-00-13-05.jpg",
  "/mothersday/match/05_PHOTO-2026-04-26-10-28-39.jpg",
];

export const POSE_PHOTOS = [
  "/mothersday/poses/pose_0_aven_smiling_PHOTO-2026-03-09-11-29-14.jpg",
  "/mothersday/poses/pose_1_aven_wonder_PHOTO-2026-05-12-12-10-34.jpg",
  "/mothersday/poses/pose_2_aven_celebration_PHOTO-2025-11-15-00-53-26_3.jpg",
  "/mothersday/poses/pose_3_aven_playing_PHOTO-2026-03-29-22-05-15.jpg",
];
